import React from 'react'
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom'

import Landing from './containers/Landing'
import CallBackFromAuth0 from './containers/CallBackFromAuth0'

import NotFound from './containers/NotFound'
import Dashboards from './containers/Dashboards'
import { Account, Accounts, AccountUsers, NewAccount, EditAccount } from './containers/Accounts'
import { Application, ApplicationBusiness, NewApplication, EditApplication, Swagger, Postman } from './containers/Applications'
import { Cruds, Crud, EditCrud } from './containers/Cruds'
import { Endpoints, Endpoint } from './containers/Endpoints'
import { Engines, NewEngine } from './containers/Engines'
import { Entities, Entity, EditEntity } from './containers/Entities'
import { NewBusinessDB, EditBusinessDB } from './containers/BusinessDB'
import { User, Users, UserEdition } from './containers/Users'
import UserSettings from './containers/Settings/UserSettings'
import UserProfile from './containers/Settings/UserProfile'
import Language from './containers/Settings/Language'
import Password from './containers/Settings/Password'
import Email from './containers/Settings/Email'
import Billing from './containers/Billing/Billing'
import Management from './containers/Management/Management'
import CustomerPlanEdition from './containers/Management/CustomerPlanEdition'
import GetStarted from './components/layout/MainNavbar/NavbarNav/helpCenter/GetStarted'
import { FilterParametersGuide } from './components/layout/MainNavbar/NavbarNav/helpCenter/FilterParametersGuide'
import FAQ from './components/layout/MainNavbar/NavbarNav/helpCenter/FAQ'
import PlanEdition from './containers/Management/PlanEdition'
import Plan from './containers/Management/Plan'
import CustomerPlan from './containers/Management/CustomerPlan'
import Element from './containers/Management/ConfigurationElement/Element'
import ElementEdition from './containers/Management/ConfigurationElement/ElementEdition'


const AppRouterPrivateDashboardRoutes = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => {
    
    const location = useLocation();
    console.log("Enter into AppRouterPrivateDashboardRoutes.js ---> location.pathname: " + location.pathname);

    return (
    
        <Switch>
                        
            <Route exact path='/main-menu' component={ CallBackFromAuth0 } />            
            {/* The follow rout comes from CallBackFromAuth0 after get user account id */}
            <Route path='/home/:id' component={ 
                (props) => <Account id={props.match.params.id} />
            } />
            <Route exact path='/dashboards' component={ Dashboards } />
            <Route exact path='/users' component={ Users } />
            <Route exact path='/users/new' component={ UserEdition } />

            <Route exact path='/helpcenter/get-started' component={ GetStarted } />
            <Route exact path='/helpcenter/filter-parameters-guide' component={ FilterParametersGuide } />
            <Route exact path='/helpcenter/faq' component={ FAQ } />

            <Route exact path='/settings/user-profile' component={ UserProfile } />
            <Route exact path='/settings/user-settings' component={ UserSettings } />
            <Route exact path='/settings/password' component={ Password } />
            <Route exact path='/settings/email' component={ Email } />
            <Route exact path='/settings/language' component={ Language } />

            <Route path='/users/edit/:id' component={
                (props) => <UserEdition id={props.match.params.id} />
            } />

            <Route path='/management' component={
                (props) => <Management id={props.match.params.id} />
            } />

            <Route path='/configurationElement/view/:id' component={
                (props) => <Element id={props.match.params.id} />
            } />
            <Route path='/configurationElement/edit/:id' component={
                (props) => <ElementEdition id={props.match.params.id} />
            } />
            <Route path='/configurationElement/new' component={
                (props) => <ElementEdition/>
            } />

            <Route path='/planEdition/view/:id' component={
                (props) => <Plan id={props.match.params.id} />
            } />
            <Route path='/planEdition/edit/:id' component={
                (props) => <PlanEdition id={props.match.params.id} />
            } />
            <Route path='/planEdition/new' component={
                (props) => <PlanEdition/>
            } />

            <Route path='/customerplan/view/:id' component={
                (props) => <CustomerPlan id={props.match.params.id} />
            } />
            <Route path='/customerplan/edit/:id' component={
                (props) => <CustomerPlanEdition id={props.match.params.id} />
            } />

            <Route path='/billing' component={
                (props) => <Billing id={props.match.params.id} />
            } />
            
            <Route path='/users/:id/account/:idAccount' component={
                (props) => <User id={props.match.params.id} idAccount={props.match.params.idAccount} />
            } />
            {/* <Route path='/users/:id' component={
                (props) => <User id={props.match.params.id}  />
            } /> */}
            <Route exact path='/accounts/:idAccount/bussinessdb/edit/:id' component={
                (props) => <EditBusinessDB idAccount={props.match.params.idAccount} id={props.match.params.id} />
            } />
            <Route exact path='/accounts/:idAccount/bussinessdb/new' component={
                (props) => <NewBusinessDB idAccount={props.match.params.idAccount} />
            } />
            <Route exact path='/accounts/:idAccount/apps/edit/:id' component={
                (props) => <EditApplication idAccount={props.match.params.idAccount} id={props.match.params.id} />
            } />
            <Route exact path='/accounts/:idAccount/apps/new' component={
                (props) => <NewApplication idAccount={props.match.params.idAccount} />
            } />
            <Route exact path='/accounts/:idAccount/apps/:idApp/bussinessdb' component={
                (props) => <ApplicationBusiness idAccount={props.match.params.idAccount} idApp={props.match.params.idApp} />
            } />

            {/* TO BE ERASED
             Init section to render diferente app from sidebar menu (avoiding Route v5 bug) -See more info in DropdownsMenuApplications.js */}
                <Route exact path='/accounts/:idAccount/apps/:id' component={
                (props) => <Application idAccount={props.match.params.idAccount} id={props.match.params.id} />
                } />
                <Route exact path='/accounts/:idAccount/appsBis/:id' component={
                (props) => <Application idAccount={props.match.params.idAccount} id={props.match.params.id} />
                } />
            {/* End section to render diferente app from sidebar menu (avoiding Route v5 bug)  */}

            {/* TO BE ERASED
                <Route exact path='/accounts/:idAccount/users' component={
                (props) => <AccountUsers idAccount={props.match.params.idAccount} />
            } /> */}
            <Route exact path='/accounts/:accountName/applications/:appId/entities/:entityId/swagger' component={
                (props) => <Swagger accountName={props.match.params.accountName} appId={props.match.params.appId} entityId={props.match.params.entityId} />
            } />
            <Route exact path='/accounts/:accountName/applications/:appId/swagger' component={
                (props) => <Swagger accountName={props.match.params.accountName} appId={props.match.params.appId} />
            } />
            <Route exact path='/accounts/:accountName/applications/:appId/postman' component={
                (props) => <Postman accountName={props.match.params.accountName} appId={props.match.params.appId} />
            } />
            <Route exact path='/entities/:idEntity/cruds' component={
                (props) => <Cruds idEntity={props.match.params.idEntity} />
            } />
            <Route exact path='/cruds/edit/:idCrud' component={
                (props) => <EditCrud idCrud={props.match.params.idCrud} />
            } />
            <Route exact path='/cruds/:idCrud' component={
                (props) => <Crud idCrud={props.match.params.idCrud} />
            } />
            <Route exact path='/accounts' component={
                (props) => <Accounts />
            } />
            <Route exact path='/accounts/new' component={
                (props) => <NewAccount />
            } />
            <Route path='/accounts/edit/:id' component={
                (props) => <EditAccount id={props.match.params.id} />
            } />
            <Route exact path='/engines' component={
                (props) => <Engines />
            } />
            <Route exact path='/engines/new' component={
                (props) => <NewEngine />
            } />
            <Route exact path='/apps/:idApp/entities' component={
                (props) => <Entities idApp={props.match.params.idApp} />
            } />
            <Route exact path='/apps/:idApp/tables/:idTable/entities/:id' component={
                (props) => <Entity idApp={props.match.params.idApp} idTable={props.match.params.idTable} id={props.match.params.id} />
            } />
            <Route exact path='/entities/edit/:id' component={
                (props) => <EditEntity id={props.match.params.id} />
            } />
            <Route exact path='/endpoints/:id' component={
                (props) => <Endpoint id={props.match.params.id} />
            } />
            <Route exact path='/apps/:idApp/endpoints' component={
                (props) => <Endpoints idApp={props.match.params.idApp} />
            } />
            <Route exact path='/logout' component={ Landing } />
            
            {/* Next route (/) is used when some alternative flows was sent explicit to "/" after some wrong path enter manualy by the user. */}
            <Route exact path='/'       component={ CallBackFromAuth0 } /> 
            <Route component={NotFound} />
        </Switch>
    )
}

export default AppRouterPrivateDashboardRoutes;